import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useGetLuaModules, useTrackWithUser } from '@ion/api';
import { filterTransformLibModulesByName, hasFilters, DEFAULT_FILTERS } from './filters';

const TransformationLibTableContext = createContext();

function useTransformationLibTableContext() {
  return useContext(TransformationLibTableContext);
}

function TransformationLibTableContextProvider({ children }) {
  const [cluster, setCluster] = useState();
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const [trackClusterSelected] = useTrackWithUser('transformation_library_cluster_selected');
  const [getLuaModules, { loading: isLoading, error, data: orgTransformLibModules }] = useGetLuaModules();

  // compute visible based on filters
  const transformLibModules = useMemo(() => {
    return filterTransformLibModulesByName({
      transformLibModules: orgTransformLibModules,
      searchTerm: filters.name,
    });
  }, [orgTransformLibModules, filters.name]);

  const hasFiltersInUse = useMemo(() => hasFilters(filters), [filters]);

  const clearFilters = () => {
    setFilters({ ...DEFAULT_FILTERS });
  };

  const handleFilterChange = updatedFilters => {
    setFilters({
      ...filters,
      ...updatedFilters,
    });
  };

  const handleClusterChange = selectedCluster => {
    setCluster(selectedCluster);
    clearFilters();

    trackClusterSelected();
    getLuaModules({ clusterId: selectedCluster });
  };

  return (
    <TransformationLibTableContext.Provider
      value={{
        cluster,
        isLoading,
        error,
        filters,
        hasFiltersInUse,
        transformLibModules,
        clearFilters,
        handleClusterChange,
        handleFilterChange,
      }}
    >
      {children}
    </TransformationLibTableContext.Provider>
  );
}

TransformationLibTableContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { TransformationLibTableContextProvider, useTransformationLibTableContext };
